import { Page as iPage } from 'iview'

export default {
  name:'Pagination',
  props: {
    loading: {
      type: Boolean
    },

    size:{
      type:String,
      default:'small'
    },
    
    page: {
      default: function() {
        return {
          pageNum: 1,
          pageSize: 10,
          total: 0,
          pageSizeOpts: [10, 20, 30, 40]
        }
      }
    }
  },
  methods:{
    handlePageChange(current) {
      this.$emit('change', {
        current,
        pageSize: this.page.pageSize
      })
      this.$emit('update', current, this.page.pageSize)
    },
    handleSizeChange(pageSize) {
      this.$emit('change', {
        current: this.page.pageNum,
        pageSize
      })
      this.$emit('update', this.page.pageNum, pageSize)
    },
  },
  render(){
    const { page , handlePageChange , handleSizeChange , size } = this
    const props = {}
    if(size == 'simple'){
      props['simple'] = true
    }else{
      props['size'] = size
    }

    return (
      <iPage total={page.total} current={page.pageNum} page-size={page.pageSize} on-on-change={handlePageChange} page-size-opts={page.pageSizeOpts} on-on-page-size-change={handleSizeChange} {...{props}} show-total show-elevator show-sizer ></iPage>
    )
  }
}